module.exports = __webpack_public_path__ + "static/Production_v2-opt-0cb8f31ee5a464ed5fb48e069c326ff7.mp4";